import { cn } from '@/lib/utils';
import { Ellipsis, PinOff } from 'lucide-react';
import { useState } from 'react';

import { Button } from '@/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';

interface ThreadOptionsMenuProps {
    onUnpin: () => void;
    className?: string;
    isOpen?: boolean;
    onOpenChange?: (open: boolean) => void;
}

export default function ThreadOptionsMenu({
    onUnpin,
    className,
    isOpen: controlledOpen,
    onOpenChange: controlledOnOpenChange
}: ThreadOptionsMenuProps) {
    const [internalOpen, setInternalOpen] = useState(false);

    // Use controlled state if provided, otherwise use internal state
    const isOpen = controlledOpen !== undefined ? controlledOpen : internalOpen;
    const onOpenChange =
        controlledOnOpenChange !== undefined
            ? controlledOnOpenChange
            : setInternalOpen;

    return (
        <DropdownMenu open={isOpen} onOpenChange={onOpenChange}>
            <DropdownMenuTrigger asChild>
                <Button
                    variant="ghost"
                    size="icon"
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                    }}
                    onTouchStart={(e) => {
                        e.stopPropagation();
                    }}
                    onTouchMove={(e) => {
                        e.stopPropagation();
                    }}
                    onTouchEnd={(e) => {
                        e.stopPropagation();
                    }}
                    className={cn(
                        'focus-visible:ring-0 focus:ring-0 focus-visible:ring-offset-0 focus:ring-offset-0 text-muted-foreground',
                        className
                    )}
                >
                    <Ellipsis />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" forceMount>
                <DropdownMenuItem
                    onClick={(e) => {
                        e.stopPropagation();
                        onUnpin();
                    }}
                   
                >
                    <PinOff className="mr-2" />
                    Unpin from organization
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
